import { Box, Grid, Typography } from "@mui/material";
import React from "react";

import InfoField from "./infoField";

import type { CompanyList } from "../../../utils/types/companyList";

const Charterer: React.FC<{
  data: CompanyList;
}> = ({ data }) => (
  <Box
    mb={1}
    p={1}
    borderRadius={1}
    sx={{
      border: "1px solid",
      borderColor: "divider",
    }}
  >
    <Typography
      variant="subtitle2"
      mb={0.5}
      overflow="hidden"
      textOverflow="ellipsis"
      whiteSpace="nowrap"
    >
      {data?.name || "Unknown"}
    </Typography>
    <Grid container spacing={1.5}>
      <Grid container item spacing={1}>
        <Grid item xs={6}>
          <InfoField label="Email" value={data?.email} />
        </Grid>
        <Grid item xs={6}>
          <InfoField label="Phone" value={data?.phone} />
        </Grid>
      </Grid>
    </Grid>
  </Box>
);

export default Charterer;
